import { Routes } from '@angular/router';
import { stepRoute as bookingForm } from './booking-form/booking-form.definition';
import { rootRoute, stepRoute as quoteForm } from './quote-form/quote-form.definition';
import { stepRoute as sendQuoteToEmail } from './send-quote-to-email/send-quote-to-email.definition';
import { stepRoute as confirmation } from './confirmation/confirmation.definition';
import { stepRoute as quoteError } from './quote-error/quote-error.definition';
import { stepRoute as enrolmentPayment } from './enrolment-payment/enrolment-payment.definition';
import { stepRoute as flywirePayment } from './flywire-payment/flywire-payment.definition';

export const stepRoutes: Routes = [rootRoute, quoteForm, bookingForm, sendQuoteToEmail, confirmation, quoteError, enrolmentPayment, flywirePayment];
